import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import axios from 'axios';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import { serverIp, } from '../../../../config/constants.js'

class UpdateCountry extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    updateCountry = () => {
        console.log("+++++++ updateCountry");

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            country: "South_Sudan",
            updatedBy: this.props.user.email,
            countryUpdatedDateNum: d.getTime(),
            countryUpdatedTime: now,
        }

        //UPDATE FIREBASE
        FbUtils.updateOrder(this.props.orderId, orderUpdates);


        //API CALL
        axios.post(serverIp + 'countries/updateCountry', {
            fbOrderKey: this.props.orderId,
            countryName: "South_Sudan"
        })
            .then((response) => {
                console.log(response.data);

            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (
            <div>
                <Button onClick={this.updateCountry}> Sudan Order </Button>
            </div>
        )
    }
}

export default UpdateCountry;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Countries/UpdateCountry.js